import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2805c402"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { key: 4 }
const _hoisted_6 = { key: 7 }
const _hoisted_7 = { key: 8 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("隐藏")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("显示")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "商家售后" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: $setup.columns,
          bordered: "",
          pagination: $setup.pagination,
          onChange: $setup.handleTableChange,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'shop_name')
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(record.shop.name), 1))
              : _createCommentVNode("", true),
            (column.key === 'shop_type_desc')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(record.shop.shop_type_desc), 1))
              : _createCommentVNode("", true),
            (column.key === 'goods_name')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(record.goods == null ? '' : record.goods.name), 1))
              : _createCommentVNode("", true),
            (column.key === 'user')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(record.user == null ? '' : record.user.nickname), 1))
              : _createCommentVNode("", true),
            (column.key === 'sn')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(record.user == null ? '' : record.user.sn), 1))
              : _createCommentVNode("", true),
            (column.key === 'goods_image')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 5,
                  src: record.goods == null ? '' : record.goods.image,
                  style: {"width":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'shop_logo')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 6,
                  src: record.shop.logo,
                  style: {"width":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'comment_image')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.goods_comment_image, (item) => {
                    return (_openBlock(), _createBlock(_component_a_image, {
                      src: item.uri,
                      key: item.uri,
                      style: {"width":"50px","margin-right":"10px"}
                    }, null, 8, ["src"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (record.status==1)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        size: "small",
                        style: {"margin":"5px"},
                        onClick: ($event: any) => ($setup.onStatus(record))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (record.status==0)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        size: "small",
                        style: {"margin":"5px"},
                        onClick: ($event: any) => ($setup.onStatus(record))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_popconfirm, {
                    title: "是否删除该评论?",
                    onConfirm: ($event: any) => ($setup.onDel(record))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    })
  ]))
}